import React, { useEffect, useRef, useState } from 'react';
import Button from '../../../../components/Button/Button';
import ButtonSecondary from '../../../../components/Button/ButtonSecondary';
import { getBusiness, uploadBusinessLogo } from '../../../../api';
import './_styles.manage-business.scss';

const MAX_LOGO_BYTES = 1024 * 1024; // 1MB
const ACCEPTED_TYPES = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  'image/svg+xml'
];

const ManageBusiness = () => {
  const [logo, setLogo] = useState(null); // saved logo (data URL)
  const [preview, setPreview] = useState(null); // pending unsaved selection
  const [saving, setSaving] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await getBusiness();
        setLogo(data.logo || null);
      } catch (err) {
        console.error('Failed to load business', err);
      }
    };
    load();
  }, []);

  const handleFile = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    if (!ACCEPTED_TYPES.includes(file.type)) {
      alert('Please choose a PNG, JPG, GIF, WEBP or SVG image.');
      return;
    }
    if (file.size > MAX_LOGO_BYTES) {
      alert('Logo must be 1MB or smaller.');
      return;
    }

    const reader = new FileReader();
    reader.onload = () => setPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    if (!preview) return;
    setSaving(true);
    try {
      await uploadBusinessLogo(preview);
      setLogo(preview);
      setPreview(null);
      if (fileInputRef.current) fileInputRef.current.value = '';
      alert('Logo saved successfully.');
    } catch (err) {
      const message =
        err.response?.data?.message || 'Error saving logo. Please try again.';
      alert(message);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setPreview(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const shown = preview || logo;

  return (
    <div className='manage-business'>
      <h3>My Business</h3>
      <div className='logo-section'>
        <label>Company Logo</label>
        <p className='hint'>
          Used on documents such as Purchase Orders. PNG, JPG, GIF, WEBP or SVG,
          max 1MB.
        </p>
        <div className='logo-preview'>
          {shown ? (
            <img src={shown} alt='Company logo' />
          ) : (
            <span className='placeholder'>No logo uploaded</span>
          )}
        </div>
        <input
          ref={fileInputRef}
          type='file'
          accept={ACCEPTED_TYPES.join(',')}
          onChange={handleFile}
        />
        <div className='actions'>
          {preview && <ButtonSecondary title='Cancel' onClick={handleCancel} />}
          <Button
            title={saving ? 'Saving...' : 'Save Logo'}
            onClick={handleSave}
            disabled={!preview || saving}
          />
        </div>
      </div>
    </div>
  );
};

export default ManageBusiness;
